module.exports = __webpack_public_path__ + "img/chalom_yes.00f5b592.png";